var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIlusDone(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 156,
    height: 156,
    viewBox: "0 0 156 156",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_173_7231)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 78,
    cy: 78,
    r: 78,
    fill: "#C33566"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_173_7231)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 40,
    width: 108,
    height: 153,
    rx: 8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.9997 54.4167C68.8163 54.4167 61.333 62.0871 61.333 71.5C61.333 80.9129 68.8163 88.5834 77.9997 88.5834C87.183 88.5834 94.6663 80.9129 94.6663 71.5C94.6663 62.0871 87.183 54.4167 77.9997 54.4167ZM85.9663 67.5709L76.5163 77.2571C76.283 77.4963 75.9663 77.6329 75.633 77.6329C75.2997 77.6329 74.983 77.4963 74.7497 77.2571L70.033 72.4225C69.5497 71.9271 69.5497 71.1071 70.033 70.6117C70.5163 70.1163 71.3163 70.1163 71.7997 70.6117L75.633 74.5409L84.1997 65.76C84.683 65.2646 85.483 65.2646 85.9663 65.76C86.4497 66.2554 86.4497 67.0584 85.9663 67.5709Z",
    fill: "#23A26D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 99,
    width: 64,
    height: 6,
    rx: 3,
    fill: "#D8DBE6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 31,
    y: 111,
    width: 94,
    height: 66,
    rx: 4,
    fill: "url(#paint0_linear_173_7231)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_173_7231",
    x1: 78,
    y1: 16.8889,
    x2: 78,
    y2: 177,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D8DBE6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D8DBE6",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_173_7231"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 156,
    height: 156,
    rx: 78,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_173_7231"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 108,
    height: 153,
    fill: "white",
    transform: "translate(24 40)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIlusDone);
export default __webpack_public_path__ + "static/media/ilus-done.41f1a6b9bddf63ea0c90ccc6c383e7ae.svg";
export { ForwardRef as ReactComponent };